import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { applyBufferData } from '../../actions/buffer';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$deliveryTimeFetchedEstimate',
  initialState,
  reducers: {
    // This will only be used when we are refetching a new ASAP time.
    setDeliveryTimeFetchedEstimate(
      state,
      action: PayloadAction<string | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetOrder, () => {
        return initialState;
      })
      .addCase(applyBufferData, (state, action) => {
        const { deliveryTimeFetchedEstimate } = action.payload;
        return deliveryTimeFetchedEstimate === undefined
          ? state
          : deliveryTimeFetchedEstimate;
      });
  },
});

export const { setDeliveryTimeFetchedEstimate } = slice.actions;
export default slice.reducer;
